document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href="#tab-size-fit"]');
  if (!link) return;
  e.preventDefault();

  // Desktop tabs are shown when .product-tabs__tab-buttons is visible
  const tabButtons = document.querySelector('.product-tabs__tab-buttons');
  const isMobile = !tabButtons || getComputedStyle(tabButtons).display === 'none';

  const target = document.getElementById(isMobile ? 'accordion-size-fit' : 'tab-size-fit');
  if (!target) return;

  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  if (target.getAttribute('aria-expanded') !== 'true') target.click();
});

// On product pages: append product title to all contact page links
if (document.body.classList.contains('template-product')) {
  var titleEl = document.querySelector('h1.product__title');
  if (titleEl) {
    var productTitle = titleEl.textContent.trim();
    document.querySelectorAll('a[href*="/pages/contact"]').forEach(function (a) {
      var url = new URL(a.href, location.origin);
      url.searchParams.set('product', productTitle);
      a.href = url.toString();
    });
  }
}

// Product image counter (product-leather-jacket-v2)
(function () {
  var counter = document.getElementById('product-image-counter');
  if (!counter) return;

  var currentEl = document.getElementById('product-image-current');
  var totalEl   = document.getElementById('product-image-total');

  function update() {
    var thumbs = Array.from(document.querySelectorAll('.product-thumbnails__item-link'));
    if (!thumbs.length) return;
    if (totalEl) totalEl.textContent = thumbs.length;
    var activeIdx = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
    if (currentEl) currentEl.textContent = activeIdx >= 0 ? activeIdx + 1 : 1;
  }

  update();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-product-thumbnail]')) setTimeout(update, 60);
  });
})();

// On the contact page: pre-fill Product Inquiry from URL param
if (document.body.classList.contains('template-page')) {
  var param = new URLSearchParams(location.search).get('product');
  if (param) {
    var field = document.querySelector('input[name="contact[Product Inquiry]"]');
    if (field) field.value = param;
  }
}

// Home "Stories": show more / show less toggle (3 on mobile, 4 on desktop by default; CSS hides the rest)
(function () {
  function init() {
    var sec = document.querySelector('[id$="__blog_posts_8dia4R"]');
    if (!sec) return;
    var grid = sec.querySelector('.blog-posts__grid');
    if (!grid || sec.querySelector('.bh-blog-toggle')) return;
    var limit = window.matchMedia('(min-width: 720px)').matches ? 4 : 3;
    if (grid.querySelectorAll('.article-item').length <= limit) return;
    var ko = document.documentElement.lang === 'ko';
    var more = ko ? '\uB354 \uBCF4\uAE30' : 'Show more stories';
    var less = ko ? '\uC811\uAE30' : 'Show less';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bh-blog-toggle';
    btn.textContent = more;
    grid.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function () {
      var open = grid.classList.toggle('is-expanded');
      btn.textContent = open ? less : more;
      if (!open) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

